import React from "react";
import './styles.css'

export class Botao extends React.Component {
    render() {
        return (
            <a href={this.props.link} className={this.props.classBotao}>{this.props.textoBotao}</a>
        );
    }
}